import { axiosInstanceWithAuth } from '../../../services/axios-instance';
import { TransactionsType } from '../utils/types';

interface TransactionOrderParam {
  [key: string]: string | null;
}

export interface TransactionGetParams {
  page?: number | null;
  take?: number | null;
  type?: number | null;
  search?: string | null;
  city?: string | null;
  order?: TransactionOrderParam | null;
  userId?: number | string;
  transactionType?: TransactionsType;
}

interface FinalizeOrderParams {
  orderId?: string | number;
}

export const TransactionApi = {
  get: async ({ userId, transactionType, ...params }: TransactionGetParams) =>
    await axiosInstanceWithAuth
      .get(`orders/${transactionType}/${userId}`, {
        params,
      })
      .catch(error => {
        throw new Error(error);
      }),
  complete: async ({ orderId }: FinalizeOrderParams) =>
    await axiosInstanceWithAuth
      .put(`orders/finalizeSale/${orderId}`)
      .catch(error => console.error(error)),
};
